export const SOCIAL_REACTION_TYPES = ['high_five', 'love', 'support', 'celebrate', 'laugh'];

export const SOCIAL_REACTION_TYPE_ICON = {
  high_five: 'high_five_like',
  love: 'heart__filled',
  support: 'support_heart',
  celebrate: 'party_popper',
  laugh: 'laugh_emoji',
};

export const SOCIAL_REACTION_TYPE_BG_CLASS = {
  high_five: 'tw-bg-primary',
  love: 'tw-bg-red-dark',
  support: 'tw-bg-green-dark',
  celebrate: 'tw-bg-purple-500',
  laugh: 'tw-bg-yellow-500',
};

export const SOCIAL_REACTION_TYPE_TEXT_CLASS = {
  high_five: 'tw-text-primary',
  love: 'tw-text-red-dark',
  support: 'tw-text-green-dark',
  celebrate: 'tw-text-purple-500',
  laugh: 'tw-text-yellow-500',
};

export const normalizeReactionType = (type) => {
  if (type == null || type === '') return 'high_five';
  const lower = String(type).toLowerCase();
  return SOCIAL_REACTION_TYPES.find((t) => t === lower) ?? 'high_five';
};

export const createEmptyReactionCounts = () => ({
  high_five: 0,
  love: 0,
  support: 0,
  celebrate: 0,
  laugh: 0,
});

/**
 * @param {Record<string, number>} counts
 * @param {number} likesCount
 * @param {string | null | undefined} likedTypeForFallback When the API omits per-type breakdown but sends
 *   `likes_count` and the current user's `liked_type`, put the total into that bucket so optimistic updates
 *   can decrement the right key (also works with multiple likers when breakdown is missing).
 */
export const normalizeReactionCounts = (counts = {}, likesCount = 0, likedTypeForFallback = null) => {
  const normalized = createEmptyReactionCounts();
  Object.entries(counts || {}).forEach(([key, value]) => {
    const canonical = normalizeReactionType(key);
    normalized[canonical] = (normalized[canonical] || 0) + (Number(value) || 0);
  });
  const totalCount = SOCIAL_REACTION_TYPES.reduce((acc, type) => acc + (Number(normalized[type]) || 0), 0);

  if (totalCount > 0 || !likesCount) return normalized;

  const bucket = normalizeReactionType(likedTypeForFallback ?? 'high_five');

  return {
    ...normalized,
    [bucket]: likesCount,
  };
};
